import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ModalService } from 'src/app/services/modal.service';
import { setLoadingSpinner } from 'src/app/store/actions/shared.action';
import { playerJoinLeague, scorerJoinLeague } from 'src/app/store/actions/tournament.action';
import { AppState } from 'src/app/store/app.state';

@Component({
  selector: 'app-assign-player',
  templateUrl: './assign-player.component.html',
  styleUrls: ['./assign-player.component.scss']
})
export class AssignPlayerComponent implements OnInit {

  players!: any;
  leagueId!: any;
  league!: any;
  leaguePlayers!: any;

  form: FormGroup

  constructor(
    private modalService: ModalService,
    private store: Store<AppState>,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.players = this.players.filter(player => !this.leaguePlayers.some(selected => selected.playerId == player.playerId));
    this.form = this.fb.group({
      playerId: ['', [Validators.required]]
    });
  }

  close(){
    this.modalService.hideAssignScorers();
  }

  confirm(){
    this.modalService.showLoadingSpinner();
    const payload = {
      leagueId: this.leagueId,
      playerId: this.playerId?.value
    }
    this.store.dispatch(playerJoinLeague({data: payload, league: this.league }))
  }

  get playerId(){
    return this.form.get('playerId')
  }

}
